module.exports = __webpack_public_path__ + "static/img/aepic-8.ee55a88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-8.jpg
// module id = pn78
// module chunks = 52